import { useState } from 'react';
import { FileDown, FileText, Sheet, File } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ExportButtonProps {
  onExport?: (format: 'pdf' | 'csv' | 'excel') => void;
  className?: string;
}

export function ExportButton({ onExport, className }: ExportButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleExport = (format: 'pdf' | 'csv' | 'excel') => {
    if (onExport) {
      onExport(format);
    } else {
      // Default behavior - could trigger download
      console.log(`Exporting as ${format.toUpperCase()}`);
    }
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={cn(
          "flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-colors",
          "bg-neutral-800 hover:bg-neutral-700 text-white border border-neutral-700",
          className
        )}
      >
        <FileDown className="w-4 h-4" />
        <span>Export</span>
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />

          {/* Dropdown Menu */}
          <div className="absolute right-0 mt-2 w-48 bg-neutral-900 border border-neutral-800 rounded-lg shadow-xl z-20 overflow-hidden">
            <button
              onClick={() => handleExport('pdf')}
              className="flex items-center gap-3 w-full px-4 py-3 text-sm text-neutral-300 hover:bg-neutral-800 transition-colors"
            >
              <FileText className="w-4 h-4 text-red-400" />
              <span>Export as PDF</span>
            </button>
            <button
              onClick={() => handleExport('csv')}
              className="flex items-center gap-3 w-full px-4 py-3 text-sm text-neutral-300 hover:bg-neutral-800 transition-colors border-t border-neutral-800"
            >
              <File className="w-4 h-4 text-green-400" />
              <span>Export as CSV</span>
            </button>
            <button
              onClick={() => handleExport('excel')}
              className="flex items-center gap-3 w-full px-4 py-3 text-sm text-neutral-300 hover:bg-neutral-800 transition-colors border-t border-neutral-800"
            >
              <Sheet className="w-4 h-4 text-emerald-400" />
              <span>Export as Excel</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
}
